import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { RoleGuard } from "@/components/RoleGuard";
import ActionsPage from "@/pages/ActionsPage";
import AddressesPage from "@/pages/AddressesPage";
import { AdminSettingsPage } from "@/pages/AdminSettingsPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import DashboardPage from "@/pages/DashboardPage";
import InvoiceDetailPage from "@/pages/InvoiceDetailPage";
import InvoicesPage from "@/pages/InvoicesPage";
import LoginPage from "@/pages/LoginPage";
import MeterReadingsPage from "@/pages/MeterReadingsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PaymentPage from "@/pages/PaymentPage";
import ScrapingPage from "@/pages/ScrapingPage";
import SettingsPage from "@/pages/SettingsPage";
import { SetupWizardPage } from "@/pages/SetupWizardPage";
import { Navigate, Route, Routes } from "react-router-dom";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/setup"
        element={
          <ProtectedRoute>
            <SetupWizardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="addresses" element={<AddressesPage />} />
        <Route path="analytics" element={<AnalyticsPage />} />
        <Route path="meter-readings" element={<MeterReadingsPage />} />
        <Route path="actions" element={<ActionsPage />} />
        <Route path="scraping" element={<ScrapingPage />} />
        <Route path="payment" element={<PaymentPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route
          path="admin/settings"
          element={
            <RoleGuard adminOnly>
              <AdminSettingsPage />
            </RoleGuard>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
